import { useMemo } from 'react';
import { parseCallPatients } from '../utils/callUtils';

/**
 * Build a taskSid → patient names map from Active Calls data.
 * Active Calls have richer patient info (patients array) than TaskRouter
 * (which only carries attributes.name).
 *
 * @param {Array} rawActiveCalls - Active calls array from the store
 * @returns {Map<string, string[]>} taskSid → array of patient full names
 */
const usePatientNameMap = (rawActiveCalls) => {
  return useMemo(() => {
    const map = new Map();
    (rawActiveCalls || []).forEach((call) => {
      if (!call.taskSid) return;
      const patients = parseCallPatients(call);
      if (patients.length > 0) {
        const names = patients
          .map((p) =>
            `${p.patientFirstName || ''} ${p.patientLastName || ''}`.trim()
          )
          .filter(Boolean);
        if (names.length > 0) {
          map.set(call.taskSid, names);
        }
      }
    });
    return map;
  }, [rawActiveCalls]);
};

export default usePatientNameMap;
